import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Collapse,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Box,
  Stack,
} from "@chakra-ui/react";

const RefundDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  subtitle,
  amount,
  methodLabel,
  methodDetail,
  error,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const hasError = Boolean(error?.title || error?.summary || error?.details);

  useEffect(() => {
    if (!isOpen) {
      setShowDetails(false);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <Text color="gray.600">{subtitle}</Text>
            <HStack justify="space-between">
              <Text fontSize="sm" color="gray.500">
                Refund Amount
              </Text>
              <Text fontWeight="semibold">{amount}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontSize="sm" color="gray.500">
                Method
              </Text>
              <HStack spacing={2}>
                <Badge colorScheme="blue" variant="subtle">
                  {methodLabel}
                </Badge>
                <Text fontSize="sm" color="gray.600">
                  {methodDetail}
                </Text>
              </HStack>
            </HStack>
            <Text fontSize="sm" color="gray.500">
              Are you sure you want to refund this payment? This action cannot be undone.
            </Text>
            {hasError ? (
              <Box borderWidth="1px" borderRadius="md" p={3} bg="red.50">
                <Text fontWeight="semibold" color="red.700">
                  {error.title || "Refund failed"}
                </Text>
                <Text fontSize="sm" color="red.600">
                  {error.summary || "Refund failed. See details for the full error."}
                </Text>
                {error.details ? (
                  <>
                    <Button
                      variant="link"
                      size="sm"
                      mt={2}
                      colorScheme="red"
                      onClick={() => setShowDetails((prev) => !prev)}
                    >
                      {showDetails ? "Hide details" : "Show details"}
                    </Button>
                    <Collapse in={showDetails} animateOpacity>
                      <Box mt={2} p={2} bg="white" borderRadius="md">
                        <Text fontSize="xs" color="gray.600" whiteSpace="pre-wrap">
                          {error.details}
                        </Text>
                      </Box>
                    </Collapse>
                  </>
                ) : null}
              </Box>
            ) : null}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading}>
            Refund Payment
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RefundDialog;
